import { TFunction } from '@lyearn/i18n';
import { PerformanceStatusEnum, QuizResultEnum } from '@/types/schema';

import { QuizDetailsContentFragment } from '../views/QuizDetails/graphql/fragments/generated/QuizDetailsContent';
import { QuizDetailsPerformanceFragment } from '../views/QuizDetails/graphql/fragments/generated/QuizDetailsPerformance';

export type QuizStatusMeta = {
  label: string;
  result: QuizResultEnum.Pass | QuizResultEnum.Fail;
};

export const getStatus = ({
  quiz,
  performance,
  t,
  useLatestAttempt,
}: {
  quiz: QuizDetailsContentFragment;
  performance?: QuizDetailsPerformanceFragment;
  t: TFunction;
  useLatestAttempt?: boolean;
}): QuizStatusMeta | null => {
  const submission = useLatestAttempt ? performance : performance?.maxSubmissionDetails;

  if (
    performance?.status === PerformanceStatusEnum.NotStarted ||
    !submission?.result ||
    submission.result === QuizResultEnum.ToBeEvaluated
  ) {
    return null;
  }

  const { score, result, maxScore } = submission;

  return {
    label: t('Common:ContentCards.QuizScore', {
      score,
      total: maxScore ?? quiz.maxScore,
    }),
    result,
  };
};

export function getIsQuizInProgress(quizPerformance?: QuizDetailsPerformanceFragment) {
  let isQuizInProgress = false;
  if (quizPerformance?.status === PerformanceStatusEnum.InProgress) {
    // even if the quiz attempt is complete but failed, status is still shown as in progress, so we need to check the result
    isQuizInProgress = quizPerformance.result !== QuizResultEnum.Fail;
  }
  return isQuizInProgress;
}
